import { render, staticRenderFns } from "./scott_message.vue?vue&type=template&id=be5826c4"
import script from "./scott_message.vue?vue&type=script&lang=js"
export * from "./scott_message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports